
import router from '@/router'
import { defineComponent, ref, onMounted, reactive } from 'vue';
import { PlusOutlined, CloseOutlined,CopyOutlined,SaveOutlined,EditOutlined, } from '@ant-design/icons-vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ja';
import 'dayjs/plugin/updateLocale';
import { holidays } from '@holiday-jp/holiday_jp';
import { selectProps } from 'ant-design-vue/es/vc-select';

export default defineComponent({
components: {
  PlusOutlined,
  CloseOutlined,
  CopyOutlined,
  SaveOutlined,
  EditOutlined,
  datepicker: VueDatePicker,
},
setup() {
  const loading = ref(false)
  const visible = ref(true)
  const isToday = ref(true)

  const patientData = reactive({
    id:'00000000',
    name:'田中太郎',
    kana:'タナカタロウ',
    birth: dayjs('1955/5/15')
  })

  const startDate = ref(dayjs().subtract(1,'M').toDate())
  const date:any = ref(null)
  const highlightedDates:any = ref([])
  const medicineDatas:any=ref([])

  const dataSource:any = ref([{}])
  const historySource:any = ref([])
  const Memos:any = ref([])
  const columns = [
    {
      dataIndex:'label',
      title:'名称',
    },
    {
      dataIndex:'when',
      title:'服用時間',
      width:'300px',
    },
    {
      dataIndex:'days',
      title:'日数',
      width:'125px',
    },
    {
      dataIndex:'count',
      title:'用量・単位',
      width:'200px',
    },
    {
      dataIndex:'operation',
      title:'操作',
      width:'100px',
    }
  ]

  const whenOptions = [
    {
      value:'before',
      label:'１日３回　食前'
    },
    {
      value:'between',
      label:'１日２回　食間'
    },
    {
      value:'after',
      label:'１日３回　食後'
    },
    {
      value:'breakfastbefore',
      label:'１日１回　朝食前'
    },
    {
      value:'breakfastafter',
      label:'１日１回　朝食後'
    },
    {
      value:'lunchbefore',
      label:'１日１回　昼食前'
    },
    {
      value:'lunchafter',
      label:'１日１回　昼食後'
    },
    {
      value:'dinnerbefore',
      label:'１日１回　夕食前'
    },
    {
      value:'dinnerafter',
      label:'１日１回　夕食後'
    },
    {
      value:'sleep',
      label:'１日１回　就寝前'
    },
    {
      value:'pain',
      label:'痛いとき'
    },
    {
      value:'fever',
      label:'発熱時'
    },
  ]

  const unitOptions = [
    {
      value:'1',
      label:'錠'
    },
    {
      value:'2',
      label:'回'
    },
    {
      value:'3',
      label:'枚'
    },
  ]

  onMounted(async() => {
    dayjs.locale('ja')
    medicineDatas.value.push({id:0,label:null,count:0,})
    startDate.value = dayjs().subtract(1,'M').toDate()

    const nowdayjs = dayjs()
    highlightedDates.value.push(nowdayjs.subtract(28,'days').toDate())
    highlightedDates.value.push(nowdayjs.subtract(21,'days').toDate())
    highlightedDates.value.push(nowdayjs.subtract(14,'days').toDate())
    highlightedDates.value.push(nowdayjs.subtract(7,'days').toDate())

    Memos.value.push({
      id:1,
      title:'病歴',
      edittitle:null,
      value:'糖尿病 腎性高血圧症',
      editvalue:'',
      isedit:false,
    })

    date.value = highlightedDates.value[3]
    handleDate(date.value)
  })

  const handleDate = (modelData:Date)=>{
    isToday.value = modelData.toLocaleDateString() === new Date().toLocaleDateString()
    historySource.value = []

    highlightedDates.value.forEach((date:Date) => {
      if(date.toLocaleDateString() === modelData.toLocaleDateString()){
        historySource.value.push({
          id:1,
          label:'ニフェジビンＬ錠１０ｍｇ「日医工」',
          when:'breakfastafter',
          days:5,
          count:1,
          unit:'1',
        })
        historySource.value.push({
          id:2,
          label:'リスミー錠２ｍｇ',
          when:'sleep',
          days:5,
          count:1,
          unit:'1',
        })
        historySource.value.push({
          id:3,
          label:'ランタン錠４０ｍｇ',
          when:'after',
          days:5,
          count:3,
          unit:'1',
        })
      }
    });

    console.log(highlightedDates.value,modelData)
  }

  const getHolyDayDetail = (date:Date) =>{
    const day = dayjs(date)
    if(day.format('YYYY-MM-DD') in holidays) {
      return holidays[day.format('YYYY-MM-DD')].name
    } else return ""
  }

  const addMedecineDatas = () => {
    dataSource.value.push({})
  }
  const removeMedecineDatas = (data:any) => {
    const index = dataSource.value.indexOf(data)
    if(index !== -1){
      dataSource.value.splice(index, 1);
    }
  }

  const change = (record:any) => {
    let check = false
    dataSource.value.forEach((item: any) => {
      if(!item.label || item.label==='') check = true
    });
    if(!record.label || check) return
    const index = dataSource.value.indexOf(record)
    if(index === dataSource.value.length - 1 || !check){
      addMedecineDatas()
    }
  }

  const clear = () => {
    dataSource.value = [{}]
  }

  const regist = () => {
    date.value = new Date()
    isToday.value = true
  }

  const getWhen = (value:any) => {
    return whenOptions.filter(e=>e.value===value)[0].label
  }

  const getUnit = (value:any) => {
    return unitOptions.filter(e=>e.value===value)[0].label
  }

  const copy = () => {
    dataSource.value = historySource.value
    dataSource.value.push({})
    regist()
  }

  const add = (record:any) => {
    if(!dataSource.value[dataSource.value.length - 1].id){
      dataSource.value.splice(dataSource.value.length - 1, 1);
    }
    dataSource.value.push(record)
    dataSource.value.push({})
  }

  const copyDisabled = (record:any) => {
    const tmp = dataSource.value.filter((e:any)=>e.id===record.id)
    return tmp.length > 0
    //return dataSource.value.indexOf(record) !== -1
  }

  const memoAdd = () => {
    Memos.value.push({
      isedit:true,
    })
  }

  const memoEdit = (memo:any) => {
    memo.edittitle = memo.title
    memo.editvalue = memo.value
    memo.isedit = true
  }
  const memoSave = (memo:any) => {
    memo.id = Memos.value.length;
    memo.title = memo.edittitle
    memo.value = memo.editvalue
    memo.isedit = false
  }

  const memoCancel = (memo:any) => {
    if(!memo.id){
      const index = Memos.value.indexOf(memo)
      if(index !== -1){
        Memos.value.splice(index, 1);
      }
    }
    memo.isedit = false
  }

  return {
      activeKey : ref('1'),
      handleDate,
      patientData,
      startDate,
      date,
      highlightedDates,
      loading,
      getHolyDayDetail,
      visible,
      medicineDatas,
      addMedecineDatas,
      removeMedecineDatas,
      dataSource,
      columns,
      change,
      whenOptions,
      unitOptions,
      clear,
      isToday,
      regist,
      historySource,
      getWhen,
      getUnit,
      copy,
      copyDisabled,
      add,
      Memos,
      memoAdd,
      memoEdit,
      memoSave,
      memoCancel,
  }
}
})
